import { useEffect } from "react";
import { lazy, Suspense } from "react";
import { useSelector } from "react-redux";

const PublicApp = lazy(() => import("../components/App/PubicApp"));
const AuthApp = lazy(() => import("../components/App/AuthApp"));

const AppRoutes = () => {
  const { admin, user } = useSelector((state) => state.auth);

  const isAdminLogged = Boolean(admin?.token);
  const isUserLogged = Boolean(user?.token);
  const isLogged = isAdminLogged || isUserLogged;

  useEffect(() => {
    if (document.location.pathname === "/" && isAdminLogged) {
      document.location.pathname = "/admin/home";
    }

    if (document.location.pathname === "/" && isUserLogged) {
      document.location.pathname = "/";
    }
  }, [isAdminLogged, isUserLogged]);

  return (
    <Suspense fallback={<div></div>}>
      {isLogged ? <AuthApp /> : <PublicApp />}
    </Suspense>
  );
};

export default AppRoutes;
